import React from 'react';
import FilterReviews from '../filter/Filter';

const HeaderMobile = ({ data }) => (
    <header>
        <FilterReviews fetchReviews={data.general_reviews}
            type={data.type}
            lastStar={data.lastStar}/>

        <h2 className="alt">{data.title}</h2>
    </header>
);

export default HeaderMobile;


// WEBPACK FOOTER //
// ./src/reviews/headers/HeaderMobile.js